// JsFromRoutes CacheKey 623544391f736b0a0018a5ec6c49a5f5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  forOrder: /* #__PURE__ */ definePathHelper('get', '/busy_times_notifications/:audience/:order_or_gift_id/:token(/:order_type)'),
}
